import axios from '../httpConfig'

export async function GetMyClientsWithOpenAccountApi(page, perPage, forQuery, typeQuery, orderBy, orderByDesc = "DESC") {
    const response = axios({
        url: `/account/me?current_page=${page}&per_page=${perPage}&typeQuery=${typeQuery}&forQuery=${forQuery}&orderBy=${orderBy}&order=${orderByDesc}`,
        method: 'get',
        headers: {
            // 'Content-Type': 'application/json-patch+json',
        }
    });
    return response
}

export async function GetClientAccountsApi(page, perPage, forQuery, typeQuery, orderBy, orderByDesc = "DESC") {
    const response = axios({
        url: `/account?current_page=${page}&per_page=${perPage}&typeQuery=${typeQuery}&forQuery=${forQuery}&orderBy=${orderBy}&order=${orderByDesc}`,
        method: 'get',
        headers: {
            // 'Content-Type': 'application/json-patch+json',
        }
    });
    return response
}